import { configureStore, ReducersMapObject } from "@reduxjs/toolkit";
import nextStepModalSlice from "@src/services/slices/nextStepModalSlice";
import roleRequestDetailsModalSlice from "@src/services/slices/resourcePlanModalSlice";
import resourcePlanOverviewSlice from "@src/services/slices/resourcePlanOverviewSlice";
import resourcePlanTableActionsSlice from "@src/services/slices/resourcePlanTableActionsSlice";
import { baseApiSlice } from "@src/services/apis/baseApiSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import featureToggleSlice from "./services/slices/featureToggleSlice";
import requestOverviewSlice from "./services/slices/requestOverviewSlice";
import resourcePlanSlice from "./services/slices/resourcePlanSlice";
import splitRoleSlice from "./services/slices/splitRoleSlice";

const apis = [baseApiSlice];

const slices: ReducersMapObject = {
  requestOverviewSlice: requestOverviewSlice.reducer,
  nextStepModalSlice: nextStepModalSlice.reducer,
  resourcePlanSlice: resourcePlanSlice.reducer,
  splitRoleSlice: splitRoleSlice.reducer,
  featureToggleSlice: featureToggleSlice.reducer,
  resourcePlanDetailsModalSlice: roleRequestDetailsModalSlice.reducer,
  resourcePlanTableActionsSlice: resourcePlanTableActionsSlice.reducer,
  resourcePlanOverviewSlice: resourcePlanOverviewSlice.reducer,
};

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: {
      ...slices,
      ...apis.reduce((reducers, slice) => {
        reducers[slice.reducerPath] = slice.reducer;
        return reducers;
      }, {}),
    },
    preloadedState,
    middleware: (getDefaultMiddleware: any) =>
      getDefaultMiddleware().concat(
        apis.map((api) => api.middleware).filter(Boolean)
      ),
  });
};

export type RootState = ReturnType<ReturnType<typeof setupStore>["getState"]>;
export type AppDispatch = ReturnType<typeof setupStore>["dispatch"];

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
